import { render } from "./TaskList.vue?vue&type=template&id=f3ad5948&scoped=true&ts=true&lang=pug"
import script from "./TaskList.vue?vue&type=script&lang=ts"
export * from "./TaskList.vue?vue&type=script&lang=ts"

import "./TaskList.vue?vue&type=style&index=0&id=f3ad5948&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3ad5948"]])

export default __exports__